<template>
  <div class="login-card-container">
    <div class="login-card__content">
      <div class="login-card__header">
        <h2 class="login-card__brand">{{ t('brand') }}</h2>
        <p class="login-card__slogan">{{ t('slogan') }}</p>
      </div>

      <form class="login-card__form" @submit.prevent="handleLogin">
        <div class="login-card__field">
          <input
            v-model.trim="snCode"
            class="login-card__input"
            type="text"
            autocomplete="username"
            :placeholder="t('placeholder')"
          />
        </div>

        <!-- 协议勾选区域 -->
        <div class="login-card__agreement">
          <label class="agreement-label">
            <input v-model="isAgreed" type="checkbox" class="agreement-checkbox" />
            <span class="custom-checkbox"></span>
            <span class="agreement-text">
              {{ t('agreePrefix') }}
              <a href="javascript:;" class="link" @click.stop="openModal('terms')">{{ t('termsTitle') }}</a>
              {{ t('and') }}
              <a href="javascript:;" class="link" @click.stop="openModal('privacy')">{{ t('privacyTitle') }}</a>
            </span>
          </label>
        </div>

        <button class="login-card__submit" type="submit">{{ t('submitBtn') }}</button>
      </form>
    </div>

    <!-- 协议详情弹窗 Modal -->
    <div v-if="activeModal" class="protocol-modal-overlay" @click.self="closeModal">
      <div class="protocol-modal-card">
        <div class="protocol-modal-header">
          <h3>{{ activeModal === 'terms' ? t('termsTitle') : t('privacyTitle') }}</h3>
          <span class="close-btn" @click="closeModal">&times;</span>
        </div>

        <div class="protocol-modal-body">
          <!-- 服务条款内容 -->
          <template v-if="activeModal === 'terms'">
            <p class="version-tag">{{ t('termsVersion') }}</p>
            <p>{{ t('termsIntro') }}</p>

            <h4>1. {{ t('t_sec1_title') }}</h4>
            <p>1.1 {{ t('t_sec1_1') }}</p>
            <p>1.2 {{ t('t_sec1_2') }}</p>
            <p>1.3 {{ t('t_sec1_3') }}</p>

            <h4>2. {{ t('t_sec2_title') }}</h4>
            <p>2.1 {{ t('t_sec2_1') }}</p>
            <p>2.2 {{ t('t_sec2_2') }}</p>
            <p>2.3 {{ t('t_sec2_3') }}</p>
            <p>2.4 {{ t('t_sec2_4') }}</p>

            <h4>3. {{ t('t_sec3_title') }}</h4>
            <p>{{ t('t_sec3_body') }}</p>

            <h4>4. {{ t('t_sec4_title') }}</h4>
            <p>4.1 {{ t('t_sec4_1') }}</p>
            <p>4.2 {{ t('t_sec4_2') }}</p>
            <p>4.3 {{ t('t_sec4_3') }}</p>
            <p>4.4 {{ t('t_sec4_4') }}</p>

            <h4>5. {{ t('t_sec5_title') }}</h4>
            <p>5.1 {{ t('t_sec5_1') }}</p>
            <p>5.2 {{ t('t_sec5_2') }}</p>
            <p>5.3 {{ t('t_sec5_3') }}</p>

            <h4>6. {{ t('t_sec6_title') }}</h4>
            <p>{{ t('t_sec6_body') }}</p>
          </template>

          <!-- 隐私政策内容 -->
          <template v-else-if="activeModal === 'privacy'">
            <p class="version-tag">{{ t('privacyVersion') }}</p>
            <p>{{ t('privacyIntro') }}</p>

            <h4>1. {{ t('p_sec1_title') }}</h4>
            <p>{{ t('p_sec1_body') }}</p>

            <h4>2. {{ t('p_sec2_title') }}</h4>
            <p>{{ t('p_sec2_body') }}</p>

            <h4>3. {{ t('p_sec3_title') }}</h4>
            <p>{{ t('p_sec3_body') }}</p>

            <h4>4. {{ t('p_sec4_title') }}</h4>
            <p>{{ t('p_sec4_body') }}</p>

            <h4>5. {{ t('p_sec5_title') }}</h4>
            <p>{{ t('p_sec5_body') }}</p>

            <h4>6. {{ t('p_sec6_title') }}</h4>
            <p>{{ t('p_sec6_body') }}</p>

            <h4>7. {{ t('p_sec7_title') }}</h4>
            <p>{{ t('p_sec7_body') }}</p>

            <h4>8. {{ t('p_sec8_title') }}</h4>
            <p>{{ t('p_sec8_body') }}</p>

            <h4>9. {{ t('p_sec9_title') }}</h4>
            <p>{{ t('p_sec9_body') }}</p>

            <h4>10. {{ t('p_sec10_title') }}</h4>
            <p>{{ t('p_sec10_body') }}</p>
          </template>
        </div>

        <div class="protocol-modal-footer">
          <button class="confirm-btn" @click="confirmModal">{{ t('confirmAgree') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  props: {
    lang: {
      type: String,
      default: 'zh'
    }
  },
  data() {
    return {
      snCode: '',
      isAgreed: false,
      activeModal: null, // 'terms' | 'privacy' | null
      i18n: {
        zh: {
          brand: '香港星辉',
          slogan: '让网络变得更简单',
          placeholder: '请输入卡片SN码',
          submitBtn: '登录',
          agreePrefix: '我已阅读并同意',
          termsTitle: '《服务条款》',
          privacyTitle: '《隐私政策》',
          and: '与',
          msgEmpty: '请输入卡片SN码',
          msgSuccess: '登录成功！',
          msgError: 'SN码错误，验证失败',
          msgNeedAgree: '请先阅读并勾选同意服务条款与隐私政策',
          confirmAgree: '已阅读并同意',
          
          /* 服务条款词典 */
          termsVersion: '版本号：V1.0 更新日期：2026-10-26',
          termsIntro: '欢迎访问【香港星辉流量卡商城】网站（下称 “本站”），在选购、下单、激活、使用流量卡前，请仔细阅读本《用户服务协议》。您提交订单、激活卡片，即代表已阅读、理解并同意本协议全部条款。',
          t_sec1_title: '主体与服务说明',
          t_sec1_1: '运营主体：香港星辉国际通信有限公司；本站为电信业务代理商 / 移动转售合作平台，卡源由基础运营商或合规转售企业提供，通信基础服务、号码归属、资费底层规则由运营商负责，本站仅提供线上展示、下单、订单查询、售后对接服务，本身不直接运营电信基础通信网络。',
          t_sec1_2: '服务范围：手机流量卡、纯流量上网卡的商品展示、在线下单、实名登记引导、激活指引、订单售后、资费查询对接。不含物联网行业卡面向个人零售（行业物联网卡仅限企业备案场景）。',
          t_sec1_3: '卡品类型：纯流量卡（仅上网，关闭语音短信），商品页会标注套餐内容、合约期、限速规则、套外资费、有效期。',
          t_sec2_title: '下单、激活与资费',
          t_sec2_1: '订单提交≠成功入网：订单提交后，需完成卡片激活，激活成功才能入网。',
          t_sec2_2: '套餐说明：套餐流量、月租、优惠期、合约、限速、断网规则、定向流量范围，以运营商后台系统为准，页面仅为宣传展示；优惠套餐多为阶段性活动，到期自动恢复标准资费，用户有义务知悉。',
          t_sec2_3: '充值：充值资金直接进入运营商账户，本站仅提供充值入口跳转，不截留资金；充值到账时效、退费规则遵循运营商规则。',
          t_sec2_4: '停机情形：涉诈风险监测、违反使用约定、超过合约规则，运营商可单方面暂停 / 关停服务，本站仅协助通知，不承担赔付责任。',
          t_sec3_title: '用户使用禁止行为',
          t_sec3_body: '用户承诺不得使用本卡用于电信网络诈骗、跑分、引流、赌博、色情、骚扰短信、改号、非法爬虫、跨境违规访问等违法活动，以及突破套餐约定使用场景。一旦监测异常，运营商有权直接封卡，套餐费用不予退还，同时上报反诈、通信管理部门，追究法律责任。',
          t_sec4_title: '平台责任与免责',
          t_sec4_1: '本站负责订单对接、问题反馈协助；网络信号、基站覆盖、网速、断网、运营商系统维护、区域性故障，由基础运营商承担，本站不做网速、信号无条件保证。',
          t_sec4_2: '因运营商政策调整、资费下架、停售套餐、政策监管要求，本站可下架卡品、停止新开户，已开户用户按运营商原有规则执行。',
          t_sec4_3: '不可抗力：政策监管、通信管控、灾害、运营商系统割接维护导致的服务中断，本站免责。',
          t_sec4_4: '本站不承诺永久不限速、永久低价，所有优惠均标注活动期限。',
          t_sec5_title: '变更、暂停、终止服务',
          t_sec5_1: '本站有权更新本协议，更新后在网站公示，继续使用即视为同意新版本。',
          t_sec5_2: '用户违规、多次实名造假、涉诈预警，本站可永久拒绝提供服务，拉黑账号。',
          t_sec5_3: '用户销户：销户需在运营商官方渠道办理，本站提供指引，不直接办理销户业务。',
          t_sec6_title: '投诉渠道',
          t_sec6_body: '客服电话：+852 5809 0414；客服微信 / 工单：+852 5613 6142',

          /* 隐私政策词典 */
          privacyVersion: '版本号：V1.0 更新日期：2026-10-26',
          privacyIntro: '本隐私政策说明【香港星辉流量卡商城】如何收集、存储、使用、共享、保护您的个人信息，严格遵循《个人信息保护法》《电信和互联网用户个人信息保护规定》《反电信网络诈骗法》等法规。',
          p_sec1_title: '适用范围',
          p_sec1_body: '本政策适用于您访问本站、浏览商品、下单购卡、咨询客服、提交售后时收集的信息；运营商实名系统收集信息，遵循运营商独立隐私政策。',
          p_sec2_title: '我们收集哪些信息',
          p_sec2_body: '自动收集设备信息（IP地址、设备型号、浏览器、访问时间、Cookie等）。不强制收集无关信息，不索要银行卡密码、短信验证码（验证码由运营商下发，本站严禁收集短信验证码）。',
          p_sec3_title: '信息用来做什么',
          p_sec3_body: '1. 完成电话卡入网核验提交运营商；2. 处理订单、通知与客服；3. 风险识别与防刷风控；4. 订单查询与套餐提醒；5. 按监管要求合规留存。',
          p_sec4_title: '信息共享与对外披露',
          p_sec4_body: '仅向基础运营商/转售企业推送入网资料，以及依法配合公安、反诈等执法机关调取。绝不出售、出租身份信息。',
          p_sec5_title: '存储、保存期限',
          p_sec5_body: '按监管要求留存，超过期限脱敏或删除；传输过程全程加密，内部设置严格访问权限。',
          p_sec6_title: '您的个人信息权利',
          p_sec6_body: '您有权查询已留存信息、更正非核心信息、申请删除本站侧订单记录、撤回Cookie授权及向客服发起投诉。',
          p_sec7_title: 'Cookie 说明',
          p_sec7_body: '本站使用 Cookie 维持登录状态与防刷风控；关闭 Cookie 可能影响部分下单功能。',
          p_sec8_title: '未成年人提示',
          p_sec8_body: '本服务不向未成年人独立售卡；未成年人办卡必须由法定监护人陪同并承担全部责任。',
          p_sec9_title: '安全措施',
          p_sec9_body: '我们采用传输加密、访问权限管控、日志审计等措施防护，如发生泄露将依法及时通知与上报。',
          p_sec10_title: '联系方式',
          p_sec10_body: '客服联系入口：+852 5809 0414。如不同意本隐私政策，请不要下单购买。'
        },
        en: {
          brand: 'Starlight',
          slogan: 'Make network simpler',
          placeholder: 'Please enter card SN code',
          submitBtn: 'Login',
          agreePrefix: 'I have read and agree to ',
          termsTitle: 'Terms of Service',
          privacyTitle: 'Privacy Policy',
          and: ' and ',
          msgEmpty: 'Please enter card SN code',
          msgSuccess: 'Login successful!',
          msgError: 'Incorrect SN code, verification failed',
          msgNeedAgree: 'Please read and check to agree with Terms & Privacy Policy',
          confirmAgree: 'Agree and Proceed',

          /* Terms English */
          termsVersion: 'Version: V1.0 Updated: 2026-10-26',
          termsIntro: 'Welcome to Hong Kong Starlight Data Card Store. Please read these Terms of Service carefully before purchasing, activating, or using our services.',
          t_sec1_title: 'Entity & Service Description',
          t_sec1_1: 'Operator: Hong Kong Starlight International Communications Limited. We act as a telecom agent/reseller platform.',
          t_sec1_2: 'Service scope includes display, online order, activation guide, and support for mobile data cards.',
          t_sec1_3: 'Card type: Pure data cards (Data only, voice & SMS disabled).',
          t_sec2_title: 'Order, Activation & Rates',
          t_sec2_1: 'Order submission does not equal instant network access until card activation is completed.',
          t_sec2_2: 'Plan details, data allowance, contract terms, and speed limit rules follow carrier system specs.',
          t_sec2_3: 'Top-ups go directly to carrier accounts; top-up time and refund rules comply with carrier policies.',
          t_sec2_4: 'Carriers may suspend service if fraud risks, policy breaches, or contract rules are violated.',
          t_sec3_title: 'Prohibited Actions',
          t_sec3_body: 'Users agree not to use cards for fraud, gambling, illegal crawling, or unapproved scenarios. Violations will lead to account termination without refund.',
          t_sec4_title: 'Platform Liability & Disclaimer',
          t_sec4_1: 'Network signals, coverage, and speed issues are handled by underlying carriers.',
          t_sec4_2: 'We reserve the right to modify or adjust card packages subject to carrier policy changes.',
          t_sec4_3: 'Force majeure: We are exempt from liability for outages caused by policy shifts, disasters, or carrier maintenance.',
          t_sec4_4: 'Unconditional forever-unlimited speeds or perpetual low rates are not guaranteed.',
          t_sec5_title: 'Service Changes & Termination',
          t_sec5_1: 'We reserve the right to update this agreement; continued usage implies consent.',
          t_sec5_2: 'Accounts associated with fraudulent identity or spam warnings will be blacklisted.',
          t_sec5_3: 'Cancellations must be processed via official carrier channels.',
          t_sec6_title: 'Complaints & Contacts',
          t_sec6_body: 'Support Tel: +852 5809 0414; WeChat/Ticket: +852 5613 6142',

          /* Privacy English */
          privacyVersion: 'Version: V1.0 Updated: 2026-10-26',
          privacyIntro: 'This Privacy Policy explains how Hong Kong Starlight collects, uses, stores, and protects your personal data.',
          p_sec1_title: 'Scope of Application',
          p_sec1_body: 'Applies to information collected when browsing, ordering, and contacting support on this website.',
          p_sec2_title: 'Information We Collect',
          p_sec2_body: 'Device info, IP, cookies. We never collect bank passwords or SMS verification codes.',
          p_sec3_title: 'How We Use Information',
          p_sec3_body: '1. Identity verification; 2. Order handling; 3. Fraud risk prevention; 4. Compliance archiving.',
          p_sec4_title: 'Information Sharing',
          p_sec4_body: 'Data is shared only with underlying carriers or law enforcement agencies as required by law. Never sold.',
          p_sec5_title: 'Storage & Retention',
          p_sec5_body: 'Retained according to telecom regulations and anonymized/deleted after the statutory period.',
          p_sec6_title: 'Your Rights',
          p_sec6_body: 'You have rights to query your records, correct non-essential details, and request deletion.',
          p_sec7_title: 'Cookie Notice',
          p_sec7_body: 'Cookies maintain session state and prevent fraud attacks. Disabling them may affect ordering.',
          p_sec8_title: 'Minors Notice',
          p_sec8_body: 'Independent purchasing is not available to minors. A legal guardian must accompany the transaction.',
          p_sec9_title: 'Security Measures',
          p_sec9_body: 'We utilize SSL encryption, access controls, and security auditing to protect user data.',
          p_sec10_title: 'Contact Us',
          p_sec10_body: 'Customer Support: +852 5809 0414. If you disagree with this policy, please do not proceed.'
        }
      }
    }
  },
  methods: {
    t(key) {
      return this.i18n[this.lang] && this.i18n[this.lang][key] !== undefined
        ? this.i18n[this.lang][key]
        : key
    },
    openModal(type) {
      this.activeModal = type
    },
    closeModal() {
      this.activeModal = null
    },
    confirmModal() {
      this.isAgreed = true
      this.closeModal()
    },
    handleLogin() {
      if (!this.snCode) {
        this.$message.warning(this.t('msgEmpty'))
        return
      }

      if (!this.isAgreed) {
        this.$message.warning(this.t('msgNeedAgree'))
        return
      }

      // 后期改为真实接口，目前暂时写死为 123
      if (this.snCode === '123') {
        this.$message.success(this.t('msgSuccess'))
        this.$emit('login-success', this.snCode)
      } else {
        this.$message.error(this.t('msgError'))
      }
    }
  }
}
</script>

<style scoped>
.login-card-container {
  width: 100%;
  padding: 20px 16px;
  box-sizing: border-box;
}

.login-card__content {
  background: linear-gradient(135deg, #1882ff 0%, #3d98ff 100%);
  border-radius: 16px;
  padding: 36px 24px;
  color: #ffffff;
  box-shadow: 0 8px 24px rgba(12, 121, 245, 0.18);
  box-sizing: border-box;
}

.login-card__header {
  text-align: center;
  margin-bottom: 32px;
}

.login-card__brand {
  font-size: 24px;
  font-weight: 700;
  margin: 0 0 6px 0;
}

.login-card__slogan {
  font-size: 14px;
  margin: 0;
  opacity: 0.85;
}

.login-card__form {
  width: 100%;
}

.login-card__field {
  border-bottom: 1px solid rgba(255, 255, 255, 0.65);
  margin-bottom: 20px;
  padding-bottom: 6px;
}

.login-card__input {
  width: 100%;
  background: transparent;
  border: none;
  outline: none;
  color: #ffffff;
  font-size: 16px;
  box-sizing: border-box;
}

.login-card__input::placeholder {
  color: rgba(255, 255, 255, 0.7);
}

/* 协议勾选复选框样式 */
.login-card__agreement {
  margin-bottom: 24px;
  font-size: 12px;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.9);
}

.agreement-label {
  display: flex;
  align-items: flex-start;
  cursor: pointer;
  user-select: none;
}

.agreement-checkbox {
  display: none;
}

.custom-checkbox {
  width: 14px;
  height: 14px;
  border: 1.5px solid rgba(255, 255, 255, 0.85);
  border-radius: 3px;
  margin-right: 8px;
  margin-top: 2px;
  flex-shrink: 0;
  position: relative;
  box-sizing: border-box;
  transition: all 0.2s ease;
}

.agreement-checkbox:checked + .custom-checkbox {
  background-color: #ffffff;
  border-color: #ffffff;
}

.agreement-checkbox:checked + .custom-checkbox::after {
  content: '';
  position: absolute;
  left: 4px;
  top: 1px;
  width: 3px;
  height: 7px;
  border: solid #0c79f5;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.agreement-text .link {
  color: #ffffff;
  font-weight: 600;
  text-decoration: underline;
  margin: 0 2px;
}

.login-card__submit {
  width: 100%;
  height: 44px;
  background-color: #ffffff;
  color: #0c79f5;
  border: none;
  border-radius: 22px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s, transform 0.2s;
}

.login-card__submit:active {
  opacity: 0.9;
  transform: scale(0.98);
}

/* 协议弹窗样式 Modal */
.protocol-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(4px);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.protocol-modal-card {
  background: #ffffff;
  border-radius: 16px;
  width: 100%;
  max-width: 380px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.2);
  animation: modalFadeIn 0.25s ease-out;
}

@keyframes modalFadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

.protocol-modal-header {
  padding: 16px 20px;
  border-bottom: 1px solid #eef1f6;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.protocol-modal-header h3 {
  margin: 0;
  font-size: 16px;
  color: #1a1a1a;
  font-weight: 700;
}

.protocol-modal-header .close-btn {
  font-size: 22px;
  color: #909399;
  cursor: pointer;
  line-height: 1;
}

.protocol-modal-body {
  padding: 16px 20px;
  overflow-y: auto;
  font-size: 13px;
  color: #4a4a4a;
  line-height: 1.6;
  text-align: left;
}

.protocol-modal-body .version-tag {
  font-size: 11px;
  color: #909399;
  margin-bottom: 12px;
}

.protocol-modal-body h4 {
  font-size: 14px;
  color: #1a1a1a;
  margin: 14px 0 6px 0;
}

.protocol-modal-body p {
  margin: 0 0 8px 0;
}

.protocol-modal-footer {
  padding: 12px 20px;
  border-top: 1px solid #eef1f6;
  text-align: center;
}

.confirm-btn {
  width: 100%;
  height: 40px;
  background-color: #0c79f5;
  color: #ffffff;
  border: none;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.confirm-btn:active {
  opacity: 0.9;
}
</style>